import './Home.css'
import React, { Component } from 'react'
import Navbar from '../Navbar/Navbar'

import IndividualIntervalsExample from '../Slider/Slider'

import Introduction from '../Introduction/Introduction'

import Vision from '../Vision/Vision'

import Focus from '../Focus/Focus'
import Teams from '../Teams/Teams'

import Footer from '../Footer/Footer'
import Salaamstree from '../Salaamstree/Salaamstree'

export class Home extends Component {


    componentDidMount() {
        window.scrollTo(0, 0);
    }


    render() {
        
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  
                <Navbar></Navbar>
                <IndividualIntervalsExample></IndividualIntervalsExample>
                <div id='about' style={{ display: "flex", flexDirection: "column",width:"100%",alignItems:"center"}}>
                    <Introduction></Introduction>
                    <Vision></Vision>
                </div>

                <Focus></Focus>
                <Teams></Teams>
                <Salaamstree></Salaamstree>

                <Footer></Footer>
                



            </div>
        )
    }
}

export default Home
